import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { InvoiceFilterConfig } from '@app/core/models/invoices/invoice-filter-config.model';
import { InvoiceFilters } from '@app/core/models/invoices/invoice-filters.model';
import { InvoiceSearchCriteriaModel } from '@app/core/models/invoices/invoice-search-criteria.model';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { ReferentialsModel } from '@app/core/models/referentials/referentials.model';
import { WaitingFlags } from '@app/core/models/referentials/waiting-flag.model';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { UserProfileModel } from '@app/core/models/users/user-profile.model';
import { AssetService } from '@app/core/services/asset.service';
import { InvoiceService } from '@app/core/services/invoice.service';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { InvoiceForwardComponent } from '@app/features/invoices/actions/forward/invoice-forward.component';
import { AttachmentComponent } from '@app/shared/components/attachment/attachment.component';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { DropdownHelper } from '@app/shared/models/dropdown-helper.model';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import {
  TableActionIcon,
  TableIndication,
  TableMassAction,
  TableRowAction,
} from '@app/shared/models/table-action-type.model';
import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { InvoiceSelectRef1Component } from '../../actions/invoice-select-ref1/invoice-select-ref1.component';
import { InvoiceListPPRErrorsComponent } from '../../actions/listPPRErrors/invoice-list-pprerrors/invoice-list-pprerrors.component';
import { InvoiceFilterService } from '../invoice-filter-service';
import { InvoicePPRLogModel } from '@app/core/models/invoices/invoice-pprlog.model';
import { ExpenseFamilyTypeRef } from '@app/core/models/referentials/expense-family-type.model';
import { ReferentialItemByCode } from '@app/core/models/shared/referential-item-by-code.model';

@Component({
  selector: 'app-invoice-list-dispatched',
  templateUrl: './invoice-list-dispatched.component.html',
  styleUrls: ['./invoice-list-dispatched.component.scss'],
})
export class InvoiceListDispatchedComponent
  extends InvoiceFilterService
  implements OnInit, OnDestroy
{
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  invoices: InvoiceModel[];
  data: InvoiceModel[] = [];
  tableRowActions: TableRowAction[] = [];
  tableMassActions: TableMassAction[] = [];
  tableIndications: TableIndication[] = [];

  selectedItemsReverseFactoring: ReferentialItem[] = [];
  dropdownListReverseFactoring: ReferentialItem[] = [];

  selectedItemsWorkingSituation: ReferentialItem[] = [];
  dropdownListWorkingSituation: ReferentialItem[] = [];

  selectedItemsRecipientEntities: ReferentialItem[] = [];
  dropdownListRecipientEntities: ReferentialItem[] = [];

  selectedItemsAssets: ReferentialItem[] = [];
  dropdownListAssets: ReferentialItem[] = [];

  selectedItemsControl: ReferentialItem[] = [];
  dropdownListControl: ReferentialItem[] = [];

  selectedItemsExpenseFamilyTypes : ExpenseFamilyTypeRef[] = [];
  dropdownListExpenseFamilyTypes : ExpenseFamilyTypeRef[] = [];
  expenseFamilyDropdownSettings : IDropdownSettings = {};

  selectedItemsExpenseTradeTypes : ReferentialItemByCode[] = [];
  dropdownListExpenseTradeTypes : ReferentialItemByCode[] = [];
  expenseTradeDropdownSettings : IDropdownSettings = {};

  dropdownListWaitingFlags: ReferentialItem[] = [];
  selectedItemsWaitingFlags: ReferentialItem[] = [];

  dropdownSettings: IDropdownSettings = {};
  multipleSelectionWithSearchDropdownSettings: IDropdownSettings = {};
  multipleSelectionWithoutSearchDropdownSettings: IDropdownSettings = {};

  selectedIds: string[] = [];
  isDownloading: boolean = false;
  configKey: string;
  filterStorageKey: string;
  exportFileName: string;
  detailType: string;
  isDispatched: boolean;
  isWaitingInvoice: boolean;
  panelOpenState: boolean = true;
  canCreateManualInvoice: boolean = false;

  title: string;

  constructor(
    public dialog: MatDialog,
    private invoiceService: InvoiceService,
    private changeDetectorRefs: ChangeDetectorRef,
    protected route: ActivatedRoute,
    private router: Router,
    private multiSelectModel: MultiSelectModel,
    private dropdownHelper: DropdownHelper,
    public assetService: AssetService,
    public recipientEntitiesServie: RecipientEntitiesService,
    protected sessionStorageService: SessionStorageService,
    private authenticationInfoService: AuthenticationInfoService
  ) {
    super(route, sessionStorageService, assetService, recipientEntitiesServie);
    this.invoiceFiltersConfig = new InvoiceFilterConfig(
      true,
      true,
      true,
      true,
      true,
      false,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      true,
      true
    );

    this.authenticationInfoService.userProfileLoaded$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((userProfile) => !_.isNil(userProfile))
      )
      .subscribe((userProfile: UserProfileModel) => {
        this.canCreateManualInvoice = userProfile.ContainIsPPRGroup;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  ngOnInit(): void {
    this.restoreFilters((data: InvoiceFilters) => {
      this.selectedItemsRecipientEntities = data?.RecipientEntities ?? [];
      this.selectedItemsAssets = data?.Assets ?? [];
      this.selectedItemsReverseFactoring = data?.ReverseFactoring ?? [];
      this.selectedItemsWorkingSituation = data?.WorkingSituation ?? [];
      this.selectedItemsControl = data?.Controls ?? [];
      this.selectedItemsWaitingFlags = data?.WaitingFlags ?? [];
      this.selectedItemsExpenseFamilyTypes = data?.ExpenseFamilyTypes ?? [];
      this.selectedItemsExpenseTradeTypes = data?.ExpenseTradeTypes ?? [];
    });

    this.route.data.subscribe((data) => {
      this.invoices = data.invoices;
      
      const referentials: ReferentialsModel = data.referentials;
      if (this.route.snapshot.data.detailType === InvoiceViewType.WAITING) {
        this.dropdownListWaitingFlags = referentials.WaitingFlags.filter(
          (flag) => flag.Id != WaitingFlags.None
        );
        this.dropdownListExpenseFamilyTypes = referentials.ExpenseFamilyTypes.map(item => ({
          ...item,
          DisplayName: `${item.FamilyCode} - ${item.FamilyLabel}`
        }));
        this.dropdownListExpenseTradeTypes = referentials.ExpenseTradeTypes.map(item => ({
          ...item,
          DisplayName: `${item.Code} - ${item.Label}`
        }));
      }

      this.data = this.innerFilterInvoices(
        this.invoices,
        this.getFilters(),
        false
      );
    });

    this.detailType = this.route.snapshot.data.detailType;
    this.configKey = this.route.snapshot.data.configKey;
    this.filterStorageKey = this.route.snapshot.data.searchFilterKey;
    this.dropdownSettings = this.multiSelectModel.getSingleSelection(false);
    this.dropdownListReverseFactoring =
      this.dropdownHelper.getYesOrNoDropdownList();
    this.dropdownListWorkingSituation =
      this.dropdownHelper.getYesOrNoDropdownList();
    this.dropdownListControl = this.dropdownHelper.getYesOrNoDropdownList();
    this.multipleSelectionWithSearchDropdownSettings =
      this.multiSelectModel.getMultipleSelection(true);
    this.multipleSelectionWithSearchDropdownSettings.allowRemoteDataSearch =
      true;
    this.multipleSelectionWithoutSearchDropdownSettings =
      this.multiSelectModel.getSingleSelection(false);


    this.expenseTradeDropdownSettings = new MultiSelectModel().getSettings(
      'Code',
      'DisplayName',
      false,
      true,
      true,
      false
    );

    this.expenseFamilyDropdownSettings = new MultiSelectModel().getSettings(
      'FamilyCode',
      'DisplayName',
      false,
      true,
      true,
      false
    );

    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.ZOOM,
        'Voir le détail de la facture',
        this.onZoom
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.PDF,
        'Ouvrir la facture',
        this.onOpenPdf
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.ATTACH,
        'Joindre un document',
        this.onAttach
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.FORWARD,
        'Transférer la facture',
        this.onForward
      )
    );

    if (this.detailType === InvoiceViewType.DISPATCHED) {
      this.title = 'FACTURES A TRAITER';
      this.isDispatched = true;
      this.exportFileName = 'Factures_A_Traiter';

      this.tableRowActions.push(
        new TableRowAction(
          TableActionIcon.PROCESS,
          'Traiter la facture',
          this.onProcess,
          this.ensureInvoiceHasPrimaryReference
        )
      );
      this.tableMassActions.push(
        new TableMassAction(
          TableActionIcon.PROCESS,
          'Traiter les factures',
          this.onProcessInvoices,
          this.ensureSelectedItemsAreNotVoucherAndHavePrimaryReference
        )
      );
    } else if (this.detailType === InvoiceViewType.WAITING) {
      this.title = 'FACTURES EN ATTENTE';
      this.isWaitingInvoice = true;
      this.exportFileName = 'Factures_En_Attente';
    } else if (this.detailType === InvoiceViewType.CONTROL) {
      this.title = 'FACTURES A CONTROLER';
      this.exportFileName = 'Factures_A_Contrôler';
      this.tableRowActions.push(
        new TableRowAction(
          TableActionIcon.CHECK,
          'Contrôler la facture',
          this.onCheckInvoice,
          this.ensureInvoiceHasPrimaryReference
        )
      );
      this.tableMassActions.push(
        new TableMassAction(
          TableActionIcon.CHECK,
          'Contrôler les factures',
          this.onCheckInvoices,
          this.ensureSelectedItemsHavePrimaryReference
        )
      );
    }

    this.tableIndications.push(
      new TableIndication(
        TableActionIcon.ERROR,
        "L'association Référence 1 et société n'est pas conforme",
        (invoice: InvoiceModel) => invoice.SupplierHasWarning
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.PPR_ERROR,
        'Historique des retours PPR',
        this.onListPPRErrors,
        (invoice: InvoiceModel) => invoice.InvoicePPRLogsErrorCount > 0
      )
    );

    if (!this.isDispatched) this.canCreateManualInvoice = false;
  }

  dateChangeSearch(result: any) {
    this.dateChange(result.type, result.selectedDate);
    this.filterData(true);
  }

  filterData(persist: boolean) {
    this.invoiceSearchCriteriaModel.IsReverseFactoring =
      this.selectedItemsReverseFactoring &&
      this.selectedItemsReverseFactoring.length == 1
        ? this.selectedItemsReverseFactoring[0].Label == 'Oui'
        : '';
    this.invoiceSearchCriteriaModel.IsWorkingSituation =
      this.selectedItemsWorkingSituation &&
      this.selectedItemsWorkingSituation.length == 1
        ? this.selectedItemsWorkingSituation[0].Label == 'Oui'
        : '';
    this.data = this.innerFilterInvoices(
      this.invoices,
      this.getFilters(),
      persist
    );
  } 

  onSelectAll(items: any, filter: string) {
    switch (filter) {
      case 'ReverseFactoring':
        this.selectedItemsReverseFactoring = items;
        break;
      case 'WorkingSituation':
        this.selectedItemsWorkingSituation = items;
        break;
      case 'Check':
        this.selectedItemsControl = items;
        break;
      case 'assets':
        this.selectedItemsAssets = items;
        break;
      case 'recipientEntity':
        this.selectedItemsRecipientEntities = items;
        break;
      case 'waitingFlags':
        this.selectedItemsWaitingFlags = items;
        break;
      case 'expenseFamily':
        this.selectedItemsExpenseFamilyTypes = items;
        break;
      case 'expenseTrade':
        this.selectedItemsExpenseTradeTypes = items;
        break;
    }

    this.filterData(true);
  }

  onForward = (data: InvoiceModel) => {
    const forwardModal = new ModalHelper().getForwardInvoiceModalConfig(
      data.Number,
      data.Id,
      InvoiceViewType.DISPATCHED,
      false,
      true
    );
    const dialogRef = this.dialog.open(InvoiceForwardComponent, forwardModal);

    dialogRef.afterClosed()!.subscribe((isSuccess: boolean) => {
      if (isSuccess) {
        this.invoiceService.removeFromWaitingStatus(data.Id).subscribe(() => {
          this.invoices = this.invoices.filter((i) => i.Id != data.Id);
          this.data = this.invoices;
        });
      }
    });
  };

  onAttach = (data: InvoiceModel) => {
    const attachModal = new ModalHelper().getAttachModalConfig(
      'Joindre un document',
      `Veuillez choisir un document à joindre pour la facture numéro : <strong>${data.Number}</strong>`,
      data.Id,
      this.uploadFile
    );
    this.dialog.open(AttachmentComponent, attachModal);
  };

  uploadFile = (id: string, file: File): Observable<any> => {
    return this.invoiceService.attachInvoice(id, file);
  };

  onProcess = (invoice: InvoiceModel) => {
    if (
      !invoice.IsPPR &&
      invoice.IsVoucher &&
      (!invoice.ShouldBeChecked || invoice.Checked)
    ) {
      this.onProcessVoucher(invoice);
    } else {
      this.innerProcess(invoice);
    }
  };

  innerProcess = (invoice: InvoiceModel): void => {
    if (invoice.IsVoucher) {
      this.onProcessVoucher(invoice);
      return;
    }
    this.openConfirmProcessInvoice(invoice.Id);
  };

  onCheckInvoice = (data: InvoiceModel) => {
    const processModal = new ModalHelper().getConfirmationConfig(
      'Êtes-vous sûr de vouloir contrôler cette facture ?'
    );
    const dialog = this.dialog.open(ModalComponent, processModal);

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.onConfirmCheckInvoice(data.Id);
      }
    });
  };

  onCheckInvoices = (invoicesId: string[]) => {
    const processModal = new ModalHelper().getConfirmationConfig(
      'Êtes-vous sûr de vouloir contrôler ces factures ?'
    );
    const dialog = this.dialog.open(ModalComponent, processModal);
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.onConfirmCheckInvoices(invoicesId);
      }
    });
  };

  onConfirmCheckInvoice(invoiceId: string): void {
    this.invoiceService
      .checkInvoice(invoiceId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.invoices = this.invoices.filter((i) => i.Id != invoiceId);
        this.data = this.invoices;
        this.filterData(true);
      });
  }

  onConfirmCheckInvoices(invoicesId: string[]): void {
    this.invoiceService
      .checkInvoices(invoicesId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.invoices = this.invoices.filter((i) => !invoicesId.includes(i.Id));
        this.data = this.invoices;
        this.filterData(true);
      });
  }

  onZoom = (data: InvoiceModel) => {
    this.router.navigate(['invoices', this.detailType, 'detail', data.Id]);
  };

  onProcessInvoices = (data: string[]) => {
    this.openConfirmProcessInvoices(data);
  };

  openConfirmProcessInvoice = (invoiceId: string) => {
    this.invoiceService.processInvoice(invoiceId).subscribe(() => {
      this.changeDetectorRefs.detectChanges();
      this.invoices = this.invoices.filter((i) => i.Id != invoiceId);
      this.data = this.invoices;
      this.filterData(true);
    });
  };

  openConfirmProcessInvoices = (invoicesId: string[]) => {
    this.invoiceService.processInvoices(invoicesId).subscribe(() => {
      this.changeDetectorRefs.detectChanges();
      this.invoices = this.invoices.filter((i) => !invoicesId.includes(i.Id));
      this.data = this.invoices;
      this.filterData(true);
    });
  };

  ensureSelectedItemsAreNotVoucherAndHavePrimaryReference = (
    data: string[]
  ): boolean => {
    const selectedInvoices = this.data.filter((invoice: InvoiceModel) =>
      data.includes(invoice.Id)
    );

    return !selectedInvoices.some(
      (invoice: InvoiceModel) =>
        ((invoice.IsVoucher ||
          !this.ensureInvoiceHasPrimaryReference(invoice)) &&
          this.asNotSupplierEvaluaValue(invoice)) ||
        this.canProcessPPR(invoice)
    );
  };

  ensureSelectedItemsHavePrimaryReference = (data: string[]): boolean => {
    const selectedInvoices = this.data.filter((invoice: InvoiceModel) =>
      data.includes(invoice.Id)
    );
    return !selectedInvoices.some(
      (invoice: InvoiceModel) =>
        !this.ensureInvoiceHasPrimaryReference(invoice) ||
        this.asNotSupplierEvaluaValue(invoice)
    );
  };

  ensureInvoiceHasPrimaryReference = (invoice: InvoiceModel): boolean => {
    return (
      !_.isNil(invoice.PrimaryReference) &&
      invoice.PrimaryReference.length > 0 &&
      !_.isNil(invoice.SupplierEvaluaCompanyName) &&
      !this.canProcessPPR(invoice)
    );
  };

  asNotSupplierEvaluaValue = (invoice: InvoiceModel): boolean => {
    return _.isNil(invoice.SupplierEvaluaCompanyName);
  };

  canProcessPPR = (invoice: InvoiceModel): boolean => {
    return invoice.IsPPR;
  };

  onProcessVoucher = (voucher: InvoiceModel) => {
    this.router.navigate(['invoices/voucher/process/', voucher.Id]);
  };

  onOpenPdf = (data: InvoiceModel) => {
    window.open(`invoices/${this.detailType}/detail-pdf/${data.Id}`, '_blank');
  };

  onListPPRErrors = (data: InvoiceModel) => {
    this.invoiceService
      .getErrorsPPRById(data.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoicePPRLogs: InvoicePPRLogModel[]) => {
        data.InvoicePPRLogs = invoicePPRLogs;

        const modalConfig = new ModalHelper().getInvoicePPRLogsConfig(data);
        const dialog = this.dialog.open(
          InvoiceListPPRErrorsComponent,
          modalConfig
        );

        return dialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe();
      });
  };

  onClearFilters = (): void => {
    this.selectedItemsReverseFactoring = [];
    this.selectedItemsWorkingSituation = [];
    this.selectedItemsControl = [];
    this.selectedItemsAssets = [];
    this.selectedItemsRecipientEntities = [];
    this.selectedItemsWaitingFlags = [];
    this.selectedItemsExpenseFamilyTypes = [];
    this.selectedItemsExpenseTradeTypes = [];
    this.invoiceSearchCriteriaModel = new InvoiceSearchCriteriaModel();
    this.filterData(true);
    this.onFiltersCleared.next();
  };

  protected onAssetFetched(assets: ReferentialItem[]) {
    this.dropdownListAssets = assets;
  }

  protected onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]) {
    this.dropdownListRecipientEntities = recipientEntities;
  }

  private getFilters(): InvoiceFilters {
    return {
      Checked:
        this.selectedItemsControl && this.selectedItemsControl.length == 1
          ? this.selectedItemsControl[0].Label == 'Oui'
          : '',
      Assets: this.selectedItemsAssets,
      RecipientEntities: this.selectedItemsRecipientEntities,
      WorkingSituation: this.selectedItemsWorkingSituation,
      ReverseFactoring: this.selectedItemsReverseFactoring,
      Controls: this.selectedItemsControl,
      WaitingFlags: this.selectedItemsWaitingFlags,
      ExpenseFamilyTypes: this.selectedItemsExpenseFamilyTypes,
      ExpenseTradeTypes: this.selectedItemsExpenseTradeTypes,
    } as InvoiceFilters;
  }

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }

  onShowFilter(panelvalue: boolean) {
    this.panelOpenState = panelvalue;
  }

  onCreateManual = () => {
    const refSelectModal = new ModalHelper().getSelectRef1ModalConfig();
    const dialog = this.dialog.open(InvoiceSelectRef1Component, refSelectModal);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: ReferentialItem) => {
        if (!_.isNil(value) && !_.isNil(value.Label)) {
          this.router.navigate(['invoices/manual'], {
            queryParams: { PrimaryReferenceCreateId: value.Id },
          });
        }
      });
  };
}
